import { ICONS } from '@Const/common'
import React from 'react'

interface SelectToggleProps {
    selected: boolean
    id: string
    deselect: (id: string) => void
    select: (id: string) => void
}

const SelectToggle = (props: SelectToggleProps) => {
    const { selected, id, deselect, select } = props
    return (
        <>
            {selected ? (
                <img className="select-icon" src={ICONS.check} onClick={() => deselect(id)} alt="deselect" />
            ) : (
                <div className="no-select" data-testid="select-rg-button" onClick={() => select(id)} />
            )}
        </>
    )
}
export default SelectToggle
